import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <CardsSection />
        <CommentsSection />
        <FaqSection />
        <CarouselSection />
        <AppSection />
        <FeaturesSection />
        <RankingSection />
        <UpdatesSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}